import { render } from "./replenish.vue?vue&type=template&id=5915d9ae&scoped=true&ts=true"
import script from "./replenish.vue?vue&type=script&lang=ts"
export * from "./replenish.vue?vue&type=script&lang=ts"

import "./replenish.vue?vue&type=style&index=0&id=5915d9ae&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5915d9ae"]])

export default __exports__